import axios from 'axios';
import authHeader from './auth-header';
import BasicService from './basic.service'

class RecruitmentService extends BasicService {
    getMy() {
        return this.checkError(axios.get(this.API_URL + 'recruitment/my', { headers: authHeader() }));
    }
    
    getRequirements() {
        return this.checkError(axios.get(this.API_URL + 'recruitment/requirements', { headers: authHeader() }));
    }
    
    save(data) {
        return this.checkError(axios.post(this.API_URL + 'recruitment', {...data}, { headers: authHeader() }));
    }
    
    
    // Admin
    getAdminAll(id) {
        return this.checkError(axios.get(this.API_URL + 'recruitment/admin/'+id+'/all', { headers: authHeader() }));
    }
    
    saveAdmin(data) {
        return this.checkError(axios.post(this.API_URL + 'recruitment/admin/' + data.id, {...data}, { headers: authHeader() }));
    }
    
    getAdminSingle(id) {
        return this.checkError(axios.get(this.API_URL + 'recruitment/admin/' + id, { headers: authHeader() }));
    }

    getRecruitmentInfo() {
        return this.checkError(axios.get(this.API_URL + 'recruitment/admin/info', { headers: authHeader() }));
    }

    saveRecruitmentInfo(data) {
        return this.checkError(axios.post(this.API_URL + 'recruitment/admin/info', data, { headers: authHeader() }));
    }

    editRecruitmentInfo(id, data) {
        return this.checkError(axios.put(this.API_URL + 'recruitment/admin/info/'+id, data, { headers: authHeader() }));
    }

    deleteRecruitmentInfo(id) {
        return this.checkError(axios.delete(this.API_URL + 'recruitment/admin/info/'+id, { headers: authHeader() }));
    }
}

export default new RecruitmentService();